import {
    Box,
    Card,
    Flex,
    Grid,
    Skeleton,
    SkeletonCircle,
} from "@chakra-ui/react";

const skeletonProps = {
    bg: "#DAE9FF",
    borderRadius: "md",
};

const cardProps = {
    bg: "white",
    border: "none",
    borderWidth: 0,
    boxShadow: "sm",
    borderRadius: "2xl",
};

const HelpTopicCardSkeleton = () => (
    <Card.Root {...cardProps}>
        <Card.Body
            p={{
                base: 4,
                md: 6,
            }}
        >
            <Skeleton
                {...skeletonProps}
                h="170px"
                w="100%"
                borderRadius="xl"
                mb={5}
            />

            <Skeleton
                {...skeletonProps}
                h="22px"
                w="70%"
                mb={4}
            />

            <Skeleton
                {...skeletonProps}
                h="12px"
                w="100%"
                mb={2}
            />

            <Skeleton
                {...skeletonProps}
                h="12px"
                w="90%"
                mb={2}
            />

            <Skeleton
                {...skeletonProps}
                h="12px"
                w="70%"
                mb={5}
            />

            <Flex
                justify="space-between"
                align="center"
            >
                <Skeleton
                    {...skeletonProps}
                    h="26px"
                    w="90px"
                    borderRadius="full"
                />

                <SkeletonCircle
                    bg="#DAE9FF"
                    size="10"
                />
            </Flex>
        </Card.Body>
    </Card.Root>
);

const HeroSkeleton = () => (
    <Card.Root {...cardProps}>
        <Card.Body
            p={{
                base: 4,
                md: 8,
            }}
        >
            <Skeleton
                {...skeletonProps}
                h="32px"
                w={{
                    base: "180px",
                    md: "280px",
                }}
                mb={4}
            />

            <Skeleton
                {...skeletonProps}
                h="16px"
                w={{
                    base: "100%",
                    md: "520px",
                }}
                mb={6}
            />

            <Skeleton
                {...skeletonProps}
                h="48px"
                w="100%"
                borderRadius="xl"
            />
        </Card.Body>
    </Card.Root>
);

const SupportCardSkeleton = () => (
    <Card.Root {...cardProps}>
        <Card.Body
            p={{
                base: 4,
                md: 6,
            }}
        >
            <Flex
                direction={{
                    base: "column",
                    md: "row",
                }}
                justify="space-between"
                align={{
                    base: "flex-start",
                    md: "center",
                }}
                gap={4}
            >
                <Box flex={1}>
                    <Skeleton
                        {...skeletonProps}
                        h="24px"
                        w="220px"
                        mb={3}
                    />

                    <Skeleton
                        {...skeletonProps}
                        h="12px"
                        w="100%"
                        mb={2}
                    />

                    <Skeleton
                        {...skeletonProps}
                        h="12px"
                        w="80%"
                    />
                </Box>

                <Skeleton
                    {...skeletonProps}
                    h="42px"
                    w={{
                        base: "100%",
                        md: "160px",
                    }}
                />
            </Flex>
        </Card.Body>
    </Card.Root>
);

export default function HelpTopicsSkeleton() {
    return (
        <>
            {/* Header */}

            <Box
                mb={{
                    base: 6,
                    md: 8,
                }}
            >
                <Skeleton
                    {...skeletonProps}
                    h="36px"
                    w={{
                        base: "180px",
                        md: "250px",
                    }}
                    mb={3}
                />

                <Skeleton
                    {...skeletonProps}
                    h="16px"
                    w={{
                        base: "100%",
                        md: "500px",
                    }}
                />
            </Box>

            {/* Hero */}

            <HeroSkeleton />

            {/* Help Topics */}

            <Grid
                mt={{
                    base: 6,
                    md: 8,
                }}
                templateColumns={{
                    base: "1fr",
                    sm: "repeat(2,1fr)",
                    xl: "repeat(3,1fr)",
                }}
                gap={{
                    base: 4,
                    md: 6,
                }}
            >
                {Array.from({
                    length: 6,
                }).map((_, i) => (
                    <HelpTopicCardSkeleton
                        key={i}
                    />
                ))}
            </Grid>

            {/* Bottom Support Card */}

            <Box
                mt={{
                    base: 6,
                    md: 8,
                }}
            >
                <SupportCardSkeleton />
            </Box>
        </>
    );
}